import React from "react";
import ReactQuill from "react-quill";
import CloseIcon from "../../Assets/propertiesCloseIcon.svg";
import singleChoiceIcon from "../../Assets/singleChoiceIcon.svg";
import { useDispatch } from "react-redux";
import {
  addMultiChoice,
  changeMultipleOption,
  deleteMultiChoice,
  updateItemQuestion,
} from "../../Redux/Reducer/FormSlices";

const MultipleChoicegridQuestion = ({
  id,
  question,
  module,
  questionIndex,
  openQuestion,
  setOpenQuestion,
  containerIndex,
}) => {
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  const handelAdd = (text, length) => {
    dispatch(addMultiChoice({ text, containerIndex, questionIndex, length }));
  };

  const handelDel = (text, optionIndex) => {
    dispatch(
      deleteMultiChoice({ questionIndex, containerIndex, optionIndex, text })
    );
  };
  const handelOptionChange = (e, optionIndex) => {
    const { value, name } = e.target;
    dispatch(
      changeMultipleOption({
        value,
        optionIndex,
        containerIndex,
        questionIndex,
        name,
      })
    );
  };
  return (
    <>
      <div className="singleQuestion-Container">
        {questionIndex + 1}.
        <ReactQuill
          modules={module}
          theme="snow"
          className={`custom ${openQuestion === question.id ? "focus" : ""}`}
          onFocus={() => setOpenQuestion(question.id)}
          onBlur={() => setOpenQuestion(null)}
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="multiple-Choice-Conitaner">
        <div className="rowContainer">
          {question.row.map((r, i) => {
            return (
              <div className=" inside_container">
                <div className="indise_RowConrainer ">
                  <div>{i + 1}.</div>
                  <input
                    value={r.rowText}
                    name="rowText"
                    onChange={(e) => handelOptionChange(e, i)}
                  />
                </div>
                {question.row.length > 1 ? (
                  <img
                    src={CloseIcon}
                    alt="propertiesCloseIcon"
                    onClick={() => handelDel("row", i)}
                  />
                ) : (
                  ""
                )}
              </div>
            );
          })}
          <div
            className="column_add_button"
            onClick={() => handelAdd("row", question.row.length)}
          >
            <p>{question.row.length + 1}.</p>{" "}
            <p className="add-Option">Add Columns</p>
          </div>
        </div>
        <div className="rowContainer">
          {question.column.map((c, i) => {
            return (
              <div className="inside_container">
                <div className="indise_RowConrainer ">
                  <img src={singleChoiceIcon} alt="singleChoiceIcon" />
                  <input
                    value={c.columnText}
                    name="columnText"
                    onChange={(e) => handelOptionChange(e, i)}
                  />
                </div>
                {question.column.length > 1 ? (
                  <img
                    src={CloseIcon}
                    alt="propertiesCloseIcon"
                    onClick={() => handelDel("column", i)}
                  />
                ) : (
                  ""
                )}
              </div>
            );
          })}
          <div
            className="column_add_button"
            onClick={() => handelAdd("column", question.column.length)}
          >
            <p className="add-Option">Add Columns</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default MultipleChoicegridQuestion;
